import { AuthConstants } from 'src/app/constants/auth/auth-constants';
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthentificationService } from '../../services/auth/authentification.service';
import { environment } from "../../../environments/environment";
import { EnvironmentService } from 'src/app/services/environment.service';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {

    constructor(private router: Router, private authentificationService: AuthentificationService, private environmentService: EnvironmentService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const storedAccess = this.authentificationService.getStoredAccess();
        return this.commitRequest(next, this.autherizeRequest(request, storedAccess));
    }


    private autherizeRequest(request: HttpRequest<any>, storedAccess) {
        if (!request.url.includes(AuthConstants.AUTH_ENDPOINT + AuthConstants.LOGIN_URL) && request.url.includes(this.environmentService.get().serverUrl)  && !request.url.includes(AuthConstants.PUBLIC_ENDPOINT)) {
            return request.clone({
                headers: request.headers.set('Authorization', 'Bearer ' + storedAccess?.access_token),
                params: request.params.append('uuid', storedAccess?.uuid).append('companyId', storedAccess?.companyId)
            });
        } else {
            return request;
        }
    }

    private commitRequest(next, request) {
        return next.handle(request).pipe(
            map((event: HttpEvent<any>) => {
                return event;
            }),
            catchError((httpError: HttpErrorResponse) => {
                return throwError(httpError.error);
            }));
    }

}
